import { render, staticRenderFns } from "./dialogDuplicatePage.vue?vue&type=template&id=c21f5984&scoped=true&"
import script from "./dialogDuplicatePage.vue?vue&type=script&lang=js&"
export * from "./dialogDuplicatePage.vue?vue&type=script&lang=js&"
import style0 from "./dialogDuplicatePage.vue?vue&type=style&index=0&id=c21f5984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21f5984",
  null
  
)

export default component.exports